export function concatenar(separador, ...valores) {
  const sep = separador == null ? '' : String(separador)
  return valores.filter((v) => v != null && v !== '').join(sep)
}
